import React from "react";
import PropTypes from "prop-types";
import "./costpackage_detail.scss";

class CostpackageDetailList extends React.Component {
    static propTypes = {
        costpackage: PropTypes.object
    };

    render() {
        const { className, costpackage } = this.props;
        const header = (
            <nav className="navbar">
                <span className="navbar-brand h4">Cost Package Information</span>
            </nav>
        );
        this.props.setheader(header);
        return (
            <div {...{ className: ["costpackage_detail", className].join(" ") }}>
                <div className="content">
                    <div className="row">
                        <div className="col-md-9">
                            <table className="table table-bordered">
                                {costpackage && (
                                    <thead>
                                        <tr>
                                            <th scope="col">Cost Package Code</th>
                                            <td>{costpackage.code}</td>
                                        </tr>
                                        <tr>
                                            <th scope="col">Cost Package Description</th>
                                            <td>{costpackage.name}</td>
                                        </tr>
                                        <tr>
                                            <th scope="col">Cost Package Dependency</th>
                                            <td>{costpackage.cost_package_dependency}</td>
                                        </tr>
                                        <tr>
                                            <th scope="col">Status</th>
                                            <td>{costpackage.cancelled ? "Cancelled" : "Active"}</td>
                                        </tr>
                                        <tr>
                                            <th scope="col">Vendor</th>
                                            <td />
                                        </tr>
                                    </thead>
                                )}
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CostpackageDetailList;
